import React, { useEffect, useState, useRef } from "react";
import { Grid, Card } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import CardPaginationTable from "../Pagination/CardPaginationTable";
import Loader from "../../components/Loader"
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { requestUserDatasetListSuccess } from "../../actions/dataConsoleAction";

const AllRequestData = ({ data, handleApprove, handleDeny }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const getTimeAgo = (data) => {
    if (data.length === 0) {
      return "Requested today";
    }

    const createdUTC = data[0].createdUTC;
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Requested today";
    } else if (timeDifference === 1) {
      return "Requested yesterday";
    } else {
      return `Requested on ${timeDifference} days ago`;
    }
  };

  const handleViewRequestedDetails = (id, userName) => {
    dispatch(requestUserDatasetListSuccess([]));
    navigate(`/adminconsole/requests/${id}/${userName}`);
  };

  return (
    <Grid columns={3} stackable className="request-table">
      {data.length > 0
        ? data.map((row, index) => (
            <Grid.Column key={index}>
              <Card
                fluid
                className="qac-card"
                onClick={() =>
                  handleViewRequestedDetails(row.userId, row.userName)
                }
                data-cy="view-requested-details"
              >
                <Card.Content>
                  <Card.Header>
                    <div className="requestHeaderBox">
                      <div className="requestHeaderRow">{row.userName}</div>
                      <div>
                        {row.role === "Admin"||row.role==="DatasetAdmin" ? (
                          <>
                            <div className="user-admin-box">
                              <img
                                src="/images/user-admin-box.svg"
                                alt="pdf Icon"
                              />
                              <span className="usersRoleBox">Admin</span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="user-user-box">
                              <img
                                src="/images/user-user-box.svg"
                                alt="pdf Icon"
                              />
                              <span className="usersRoleBox">User</span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Meta className="request-meta">
                    <div>
                      <span className="requestedCount">
                        <span className="request-count-box">
                          {
                            row.datasets.filter(
                              (item) => item.accessType === "RequestPending"
                            ).length
                          }
                        </span>
                        <span>Requested Datasets</span>
                      </span>
                    </div>
                  </Card.Meta>
                </Card.Content>
                <Card.Content extra className="qac-card-extra-content">
                  <div className="requestListFooter">
                    <div className="requestListFooterRow">
                      {getTimeAgo(row.datasets)}
                    </div>
                    <div></div>
                    <div className="user-card-icons grey-icons">
                      <div>
                        <img
                          className="tableButton"
                          src="/images/grey-decline.svg"
                          alt="deny"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeny(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-request-deny-link"
                        />
                      </div>
                      <div>
                        <img
                          className="tableButton"
                          src="/images/grey-tick.svg"
                          alt="Approve"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleApprove(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-request-approve-link"
                        />
                      </div>
                    </div>
                    <div className="user-card-icons color-icons">
                      <div>
                        <img
                          className="tableButton"
                          src="/images/red-circle-delete.svg"
                          alt="deny"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeny(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-request-deny-link"
                        />
                      </div>
                      <div>
                        <img
                          className="tableButton"
                          src="/images/blue-tick.svg"
                          alt="Approve"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleApprove(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-request-approve-link"
                        />
                      </div>
                    </div>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))
        : ""}
    </Grid>
  );
};

const RequestList = ({ DatasetRequestedData, handleApprove, handleDeny }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9); // Default rows per page
  const [loading, setLoading] = useState(true);
  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    };
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div>
      {loading ? (
        <div>
          <Loader />
        </div>
      ) : DatasetRequestedData.length > 0 ? (
        <>
          <AllRequestData
            data={DatasetRequestedData.slice(
              currentPage * rowsPerPage,
              (currentPage + 1) * rowsPerPage
            )}
            handleApprove={handleApprove}
            handleDeny={handleDeny}
          />
          <CardPaginationTable
            totalItems={DatasetRequestedData.length}
            page={currentPage}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
          />
        </>
      ) : (
        <div className="emptyContainer">
          <img src="/images/empty-state.svg" alt="Empty State" />
          <p className="emptyMessage">
            <span className="titleMessage">No data available</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default RequestList;
